module.exports = __webpack_public_path__ + "static/img/2017.0b18cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company/2017.png
// module id = g/8r
// module chunks = 1